import { en } from '../locales/en';
import { fr } from '../locales/fr';
import { nl } from '../locales/nl';
import { de } from '../locales/de';
import { pl } from '../locales/pl';

const translations = {
  en,
  fr,
  nl,
  de,
  pl
};

export type SupportedLanguage = 'en' | 'fr' | 'nl' | 'de' | 'pl';

export const getTranslatedError = (errorKey: string, language: SupportedLanguage = 'en'): string => {
  const t = translations[language];
  
  // Split the error key to navigate the nested object
  const keys = errorKey.split('.');
  let value: any = t;
  
  for (const key of keys) {
    if (value && typeof value === 'object' && key in value) {
      value = value[key];
    } else {
      // Fallback to English if translation not found
      const englishValue = translations.en;
      let englishResult: any = englishValue;
      for (const englishKey of keys) {
        if (englishResult && typeof englishResult === 'object' && englishKey in englishResult) {
          englishResult = englishResult[englishKey];
        } else {
          return errorKey; // Return the key if not found in English either
        }
      }
      return englishResult || errorKey;
    }
  }
  
  return value || errorKey;
};

// Common error translation functions
export const getGeneralError = (errorType: string, language: SupportedLanguage = 'en'): string => {
  return getTranslatedError(`errors.general.${errorType}`, language);
};

export const getVatError = (errorType: string, language: SupportedLanguage = 'en'): string => {
  return getTranslatedError(`errors.vat.${errorType}`, language);
};

export const getPeppolError = (errorType: string, language: SupportedLanguage = 'en'): string => {
  return getTranslatedError(`errors.peppol.${errorType}`, language);
};
